import { NAME } from './constants';

export const getData = (state: any, modalName: string): any => state?.[NAME]?.[modalName]?.data;
export const getIsOpen = (state: any, modalName: string): boolean =>
  state?.[NAME]?.[modalName]?.isOpen;
